<template>
  <popup :show="true" width="830px" @on-close="onClose">
    <div class="create-pop-body">
      <div class="create-title">创建团队</div>
      <div class="create-desc">创建团队,和小伙伴们轻松共享服装设计资源库</div>
      <Form class="create-form">
        <FormItem label="团队名称">
          <template #label>
            <div class="label">团队名称</div>
          </template>
          <Input
            size="large"
            v-model="create_form.name"
            placeholder="请输入团队名称"
          ></Input>
        </FormItem>
        <FormItem label="团队头像(可选)">
          <template #label>
            <div class="label">团队头像(可选)</div>
          </template>
          <div class="upload-team-logo">
            <img
              :src="create_form.image | default_team_logo"
              alt=""
              class="logo-container"
            />
            <div class="upload-btn">
              <Upload
                action="/"
                :data="{ dir: 'template' }"
                :before-upload="(file) => onUploadTeamLogo(file)"
                :show-upload-list="false"
              >
                <div class="btn">上传团队头像</div>
              </Upload>
              <div class="tips">支持2M以内的JPG、JPEG、PNG</div>
            </div>
          </div>
        </FormItem>
        <FormItem label="团队描述">
          <template #label>
            <div class="label">团队描述(可选)</div>
          </template>
          <Input
            type="textarea"
            :rows="5"
            size="large"
            v-model="create_form.description"
            placeholder="请输入团队描述"
          ></Input>
        </FormItem>
      </Form>
      <div class="btn-box">
        <div class="confirm-btn" @click="onCreateTeam">创建团队</div>
      </div>
    </div>
  </popup>
</template>
<script>
import { createTeam } from '@/api/index';
import Popup from "@/components/Popup.vue";
import { uploadFileToOSS } from "@/utils/oss";
export default {
  name: "CreateTeam",
  components: {
    Popup,
  },
  props: {
    show_create_team: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      create_form: {
        name: "",
        image: "",
        description: "",
      },
    };
  },
  mounted() {},
  methods: {
    async onCreateTeam(){
        try{
            const {code,msg,data} = await createTeam(this.create_form);
            if(code>0){
                this.$layer.msg(msg);
                return;
            }
            console.log('data',data);
            this.$emit('on-close',{refresh:true});
        }catch(e){
            console.log('err-create-team',e);
        }
    },
    async onUploadTeamLogo(file) {
      const url = await uploadFileToOSS(file, "template");
      if (!url) {
        this.$layer.msg("上传失败,请重试");
        return;
      }
      this.create_form.image = url;
    },
    onClose() {
      this.$emit("on-close",{refresh:false});
    },
  },
};
</script>
<style lang="scss" scoped>
.create-pop-body {
  width: 100%;
  padding: 0 45px;
  display: flex;
  flex-direction: column;
  .create-title {
    color: #1a1a1a;
    font-size: 24px;
    font-weight: bold;
    margin-top: 30px;
  }
  .create-desc {
    color: #666666;
    font-size: 14px;
    line-height: 28px;
  }
  .create-form {
    margin-top: 30px;
    .label {
      color: #1a1a1a;
      font-size: 14px;
    }
    .upload-team-logo {
      width: 100%;
      height: 100px;
      display: flex;
      column-gap: 24px;
      .logo-container {
        width: 100px;
        height: 100%;
        border-radius: 6px;
        background: #e9f1ff;
        object-fit: cover;
      }
      .upload-btn {
        display: flex;
        align-items: start;
        justify-content: center;
        flex-direction: column;
        .btn {
          width: 110px;
          height: 36px;
          background: #ebebeb;
          border-radius: 5px;
          color: #333333;
          font-size: 14px;
          line-height: 36px;
          text-align: center;
          cursor: pointer;
        }
        .tips {
          color: #b3b3b3;
          font-size: 12px;
        }
      }
    }
  }
  .btn-box {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .confirm-btn {
      width: 150px;
      height: 48px;
      line-height: 48px;
      text-align: center;
      color: #ffffff;
      border-radius: 5px;
      background: #fa3d5a;
      cursor:pointer;
    }
  }
}
</style>
